/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityBulkSearchPageRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {ActivityBulkSearchPageResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const activityBulkSearch = (request:ActivityBulkSearchPageRequest, options?: CashRequestOptions) => post<ActivityBulkSearchPageRequest, ActivityBulkSearchPageResponse>("/2.0/cash/activity-bulk-search", request, {...options, rejectOnError: true })